<template>
  <div id="app">
    <!-- <img class="starbg" src="./assets/images/bg_star.png" alt=""> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body {
  background: #000;
  padding: 0;
  margin: 0;
}
#app {
  width: 100%;
  height: 100vh;
  margin: 0 auto;
  background: url(./assets/images/bg_img.png) no-repeat;
  background-size: cover;
  position: relative;
}
.starbg {
  width: 1440px;
  /* height: 50vh; */
  margin: 0 auto;
  background: url(./assets/images/bg_star.png) no-repeat;
  /* background-size: cover; */
  position: absolute;
  left: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue